import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notifications-section__inner" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["notifications-section overscroll", { 'is-active': _ctx.active }]),
    style: _normalizeStyle({ zIndex: _ctx.active ? 2 : 1 })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "notifications-section__date",
        ref: "date"
      }, _toDisplayString(_ctx.formattedCreatedDate), 513),
      _createElementVNode("h2", {
        class: "notifications-section__title",
        ref: "title"
      }, _toDisplayString(_ctx.notificationDetails.title), 513),
      _createElementVNode("div", {
        class: "notifications-section__content",
        ref: "content",
        innerHTML: _ctx.notificationDetails.content
      }, null, 8, _hoisted_2)
    ])
  ], 6))
}